import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import { FEEDBACK_CANCELLATION_REASONS } from 'apps/auth/constants/formName';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';

const EnterYourReasonPopup = (props) => {
    const { enterYourReasonTitle, submitButton } = usePageMessages();
    const fields = useFields(FEEDBACK_CANCELLATION_REASONS);

    const [disabled, toggleDisable] = useState(true);

    useEffect(() => {
        toggleDisable(fields?.reasonDescription?.value?.length === 0);
    }, [fields?.reasonDescription?.value]);

    return (
        <ComplexPopup
            textCenter
            popupRef={props.popupRef}
            primaryButtonText={submitButton}
            primaryButtonDisabled={disabled}
            onPrimaryButtonClick={(e) => props.submitReason(e, props.reason, fields?.reasonDescription?.value)}
        >
            <Text variant="paragraph" indent="32px">
                {enterYourReasonTitle}
            </Text>
            <fieldset>
                <InputAutoDetect formName={FEEDBACK_CANCELLATION_REASONS} field={fields?.reasonDescription} />
            </fieldset>
        </ComplexPopup>
    );
};
EnterYourReasonPopup.propTypes = {
    reason: PropTypes.object.isRequired,
    submitReason: PropTypes.func.isRequired,
};
export default EnterYourReasonPopup;
